document.addEventListener('DOMContentLoaded', function() {
  const addToCartForm = document.querySelector('[data-type="add-to-cart-form"]');
  if (addToCartForm) {
    initUpsells(addToCartForm);
    
    const qtyField = document.querySelector('.quantity__input');
    if (qtyField) initQtyUpdater(qtyField);
  } else {
    console.error('Upsells could not be initialized! Add to cart form not found.')
  }
});

function initUpsells(addToCartForm) {
  addToCartForm.addEventListener('addToCartFinished', function() {
    const selectedUpsell = document.querySelector('input[name="protection-service"]:checked');

    if (selectedUpsell) {
      const upsellId = selectedUpsell.value;

      const upsellConfig = fetchConfig('javascript');
      upsellConfig.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete upsellConfig.headers['Content-Type'];

      const formData = new FormData();
      formData.append('quantity', selectedUpsell.dataset.qty);
      formData.append('id', upsellId);
      formData.append('sections', 'cart-notification-product,cart-notification-button,cart-icon-bubble');
      
      upsellConfig.body = formData;

      fetch(`${routes.cart_add_url}`, upsellConfig)
          .then((response) => response.json())
          .then((response) => {            
              const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

              if (cart) cart.renderContents(response);
          });
    }
  });
}

function initQtyUpdater(qtyField) {
  /* Event delegation: luistert op document zodat het ook werkt
     nadat product-info.js de quantity input DOM vervangt bij variant-wisseling */
  document.addEventListener('change', function(e) {
    if (!e.target.matches('.quantity__input')) return;
    const val = e.target.value;

    /* ── Protection services (mbm-upsells snippet) ── */
    document.querySelectorAll('.upsell-price').forEach((element) => {
      const qty = !isNaN(val) ? Math.ceil(parseInt(val) / parseInt(element.dataset.factor)) : 1;
      const price = parseFloat(element.dataset.price) * qty / 100;

      const checkbox = element.parentNode.querySelector('input[type="checkbox"]');
      if (checkbox) {
        checkbox.dataset.qty = qty;
      }

      element.innerText = Intl.NumberFormat("nl-NL", { style: "currency", currency: "EUR", currencyDisplay: "code" }).format(
        price
      ).replace("EUR", "");
    });

    /* ── Product Highlight upsell cards ── */
    document.querySelectorAll('[data-mb-upsell-highlight]').forEach((card) => {
      const factor = parseInt(card.dataset.factor) || 1;
      const unitPrice = parseFloat(card.dataset.unitPrice) || 0;
      const qty = !isNaN(val) ? Math.ceil(parseInt(val) / factor) : 1;
      const price = unitPrice * qty / 100;

      const priceEl = card.querySelector('[data-mb-upsell-price]');
      if (priceEl) {
        priceEl.innerText = Intl.NumberFormat("nl-NL", { style: "currency", currency: "EUR", currencyDisplay: "code" }).format(
          price
        ).replace("EUR", "");
      }

      const atcBtn = card.querySelector('[data-mb-upsell-qty]');
      if (atcBtn) {
        atcBtn.dataset.mbUpsellQty = qty;
      }
    });
  });
}